import React from 'react'

const SelectedRowsDialogContext = React.createContext()

export default SelectedRowsDialogContext
